import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import seniorityReportComponent from './seniority-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let leaveReportModule = angular.module('seniorityreport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('seniorityreport', {
    parent: 'app',
    url: '/admin/reports/seniority',
    data: {
      pageHeader: true,
      pageTitle: 'Seniority Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<seniorityreport></seniorityreport>'
  });

})

.component('seniorityreport', seniorityReportComponent);

export default leaveReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/seniority-report/seniority-report.js